import {SETEAR_USUARIO, ELIMINAR_USUARIO, PUSH_UNSUSCRIBE, SETEAR_LOADING, SNACKBAR_MSG, ERROR_CARGA_USUARIO} from 'types';

import clienteAxios from 'config/axios';
import {device_data, localVar} from 'components/constants';
import getUuidDevice from 'components/uuidevice';

export const iniciarSesion = (data) => {

    return async (dispatch) => {

        const token = localVar.getItem('token');
        const uuidDevice = !localVar.getItem('uuidDevice') ? getUuidDevice() : localVar.getItem('uuidDevice');

        if(!localVar.getItem('uuidDevice')){
            localVar.setItem('uuidDevice', uuidDevice)
        }

        if(Object.keys(data).length === 0){
            data = {...data, token}
        }

        data = {...data, device_data, uuidDevice}

        dispatch({
            type: SETEAR_LOADING,
            payload: true
        })
        
        try {
            const result = await clienteAxios.post('login-token.php', data);

            console.log(result);

            if (result.data.r === 0) {
                dispatch({
                    type: ERROR_CARGA_USUARIO,
                    payload: {
                        title: 'Login', 
                        text:result.data.text, 
                        actionBtn1: () => dispatch(cerrarSesion()), 
                        btn1:'Aceptar', 
                        btn2: null
                    }
                });

                // dispatch(mostrarAlerta(result.data.text, 'Login', cerrarSesion, 'Aceptar', null));
                dispatch({
                    type: SETEAR_LOADING,
                    payload: false
                })

                cerrarSesion();

                return false;
            }

            dispatch({
                type: SETEAR_USUARIO,
                payload: result.data
            })

            /*
            Ver tiempo q hace q no entra y darle bienvenida y decirle q fue el ultimo tid q vio y en que nodo
            */
            setTimeout(() => {
                dispatch({
                    type: SNACKBAR_MSG,
                    payload: result.data.text
                })
            }, 1000);
            
            
        } catch (error) {
            console.log(error);
            dispatch({
                type: ERROR_CARGA_USUARIO,
                payload: {
                    title: 'Login', 
                    text: error, 
                    actionBtn1: () => dispatch(cerrarSesion()), 
                    btn1:'Aceptar', 
                    btn2: null
                }
            });
            
            dispatch({
                type: SETEAR_LOADING,
                payload: false
            })
        }
    }
}


export const cerrarSesion = () => {
    return async (dispatch) => {

        dispatch({
            type: PUSH_UNSUSCRIBE,
        });

        const token = localVar.getItem('token');
        const uuidDevice = !localVar.getItem('uuidDevice') ? getUuidDevice() : localVar.getItem('uuidDevice');

        const data = {
            token,
            uuidDevice
        };
        console.log(data)
        try {
            const result = await clienteAxios.post('logout.php', data);
            console.log(result);
        } catch (error) {
            console.log(error);
        }

        localVar.removeItem('token');
        localStorage.removeItem('perma');
        localStorage.removeItem('tidConfig');
        sessionStorage.clear();

        dispatch({
            type: ELIMINAR_USUARIO
        })
        
        //iesAuth.signout();
        
        if(window.location.pathname !== '/login')
            window.location.replace('/login');
    }
};